import { useEffect } from 'react';
import { useUnreadMessages } from './useUnreadMessages';

export function useAppBadge() {
  const { totalUnreadConversations } = useUnreadMessages();

  useEffect(() => {
    if (typeof navigator === 'undefined') return;

    const nav = navigator as any;

    if (totalUnreadConversations > 0 && typeof nav.setAppBadge === 'function') {
      nav.setAppBadge(totalUnreadConversations).catch(() => {
      });
    } else if (typeof nav.clearAppBadge === 'function') {
      nav.clearAppBadge().catch(() => {});
    }
  }, [totalUnreadConversations]);
}
